export const SearchTypeCustom = 9 as const;
export type TSearchTypeCustom = typeof SearchTypeCustom;
